import { isEmpty } from 'lodash';

import { createSelector } from 'reselect';

const getBatchEdit = state => state.batchEdit;

const getBatchFile = (state, fileId) => getBatchEdit(state)?.[fileId];

export const getBatchRows = createSelector(
  [getBatchFile],
  batchFile => batchFile?.rows || {}
);

const getErrors = createSelector(
  [getBatchRows],
  rows => {
    const allErrors = [];
    Object.values(rows).forEach(row => {
      if (!row.skipped && !isEmpty(row?.errors)) {
        allErrors.push(row.errors);
      }
    });
    return allErrors;
  }
);

export const getErrorsCount = createSelector(
  [getErrors],
  errors => errors?.length || 0
);

export const getBatchRow = (state, fileId, rowId) => state.batchEdit?.[fileId]?.rows?.[rowId] || null;
